// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as ManualEditOrderReasonsApiModel from "../api-model/ManualEditOrderReasonsApiModel.bs.js";

function execute(json) {
  var res = DeccoUtils$Catalyst.resolveResult(ManualEditOrderReasonsApiModel.t_decode(json), "ManualEditOrderReasonsEntityMapper.res");
  return {
          order_edit_reasons: List.map((function (reasonData) {
                  return {
                          id: reasonData.id,
                          reason: reasonData.reason
                        };
                }), res.reasons)
        };
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
